module.exports = __webpack_public_path__ + "img/home-hero_jp-4.939fbf6.jpg";